import React from 'react';

import useMobile from '@/services/hooks/useMobile';
import { PerformanceBasicInfo } from './BasicInfo';
import { PerformanceGraph } from './Graph';

export const Performance = (): JSX.Element => {
    const isMobile = useMobile();
    return (
        <>
            <PerformanceBasicInfo />
            {!isMobile && <PerformanceGraph />}
        </>
    );
};
